import React from "react";

import { UserEntityForm } from "Bands/components";
import { IFormButtons } from "shared/types";
import { copy } from "shared/assets";

import { fields } from "./formData";
import { UserFormProps } from "../UserEntityForm/UserEntityForm";

type Props = Omit<UserFormProps, "buttons">;

export const UserFlightPreferencesForm: React.FC<Props> = ({ ...rest }) => {
  const buttons: IFormButtons = {
    primary: {
      children: copy.userFlightPreferences.buttons.save,
    },
  };

  return (
    <UserEntityForm
      fields={fields}
      buttons={buttons}
      style={{ gridTemplateColumns: "repeat(2, minmax(0, 1fr))" }}
      {...rest}
    />
  );
};
